// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --color-1 : #f79860;
    --color-2 : #5F2282;
    --white:#ffffff;
    --black:#000000;
    --error-color: #a76161;
    --text-color: #adb1c9;
}

.main-header{
    background: var(--color-2);
}
/* nav bar */
.skin-blue .main-header .navbar {
    background: transparent !important;
}
/* logo bg */
.skin-blue .main-header .logo {
    background: transparent !important;
    color:var(--white);
}

.skin-blue .main-header .navbar .sidebar-toggle:hover {
    background:var(--color-2) !important;
}

.skin-blue .sidebar-menu>li.active>a {
    border-left-color: var(--color-2);
}

.skin-blue .sidebar-menu .treeview-menu>li>a{
    color: var(--text-color);
}

.info-box{
     color: var(--white);
}

.skin-blue .main-header li.user-header {
    background: linear-gradient(180deg, var(--color-2), #7a675b) !important;
}

.form-error1 {
    color: var(--error-color);
}

.box.box-warning {
    border-top-color: var(--color-2);
    color: var(--white);
}
.btn-default:hover,
.btn-default:active,
.btn-default.hover {
    background-color: var(--color-2);
    color: #fff !important;
}
.nav-tabs-custom>.nav-tabs>li.active {
    border-top-color: var(--color-2);
}
.box.box-primary {
    border-top-color: var(--color-2);
}
.box.box-danger {
    border-top: none;
}

.box-header.with-border {
    background: var(--color-2);
    color: var(--white);
}

.main-footer {
    background-image: var(--color-2) !important;
    padding: 15px;
    color: var(--white);
}

.admin-action {
    list-style: none;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333 !important;
}

.btn-box-tool {
    padding: 5px;
    font-size: 12px;
    background: transparent;
    color: #ecf0f5;
}

div#track ul li {
    list-style-type: none;
    border-bottom: 2px solid #eee;
    padding: 8px;
    padding-left: 20px;
    color: #666;
    font-size: 14px;
    margin-top: 20px;
}

div#track ul li a {
    text-decoration: none;
    color: #666;
}

div#track ul li span {
    display: inline-block;
    float: right;
    padding-right: 10px;
}

.reposrtImage img {
    width: 50px;
    /* / top: 17px;/ position: absolute;
    / right: -68px;/ left: 0px; */
}

.pagination>.active>a,
.pagination>.active>a:focus,
.pagination>.active>a:hover,
.pagination>.active>span,
.pagination>.active>span:focus,
.pagination>.active>span:hover {
    z-index: 3;
    color: var(--white);
    cursor: default;
    background-color: var(--color-2);
    border-color: var(--color-2);
}



i.fa.fa-edit.editIcon {
    font-size: 18px;
}

i.fa.fa-fw.fa-remove.deleteIcon {
    color: #b52929;
    font-size: 20px;
}



.skin-blue .wrapper,
.skin-blue .main-sidebar,
.skin-blue .left-side {
    background-color: #201804;
}

label{
    color: black;
}

.switch{
    margin-bottom: 0 !important;
}

.table>tbody>tr>td, 
.table>tbody>tr>th, 
.table>tfoot>tr>td, 
.table>tfoot>tr>th,
.table>thead>tr>td, 
.table>thead>tr>th{
    vertical-align: middle !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Css/Header.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;AACA,YAAY;AACZ;IACI,kCAAkC;AACtC;AACA,YAAY;AACZ;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;KACK,mBAAmB;AACxB;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;AACA;;;IAGI,gCAAgC;IAChC,sBAAsB;AAC1B;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX;iCAC6B;AACjC;;AAEA;;;;;;IAMI,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,4BAA4B;AAChC;;;;AAIA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;;AAIA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;;;;IAMI,iCAAiC;AACrC","sourcesContent":[":root{\n    --color-1 : #f79860;\n    --color-2 : #5F2282;\n    --white:#ffffff;\n    --black:#000000;\n    --error-color: #a76161;\n    --text-color: #adb1c9;\n}\n\n.main-header{\n    background: var(--color-2);\n}\n/* nav bar */\n.skin-blue .main-header .navbar {\n    background: transparent !important;\n}\n/* logo bg */\n.skin-blue .main-header .logo {\n    background: transparent !important;\n    color:var(--white);\n}\n\n.skin-blue .main-header .navbar .sidebar-toggle:hover {\n    background:var(--color-2) !important;\n}\n\n.skin-blue .sidebar-menu>li.active>a {\n    border-left-color: var(--color-2);\n}\n\n.skin-blue .sidebar-menu .treeview-menu>li>a{\n    color: var(--text-color);\n}\n\n.info-box{\n     color: var(--white);\n}\n\n.skin-blue .main-header li.user-header {\n    background: linear-gradient(180deg, var(--color-2), #7a675b) !important;\n}\n\n.form-error1 {\n    color: var(--error-color);\n}\n\n.box.box-warning {\n    border-top-color: var(--color-2);\n    color: var(--white);\n}\n.btn-default:hover,\n.btn-default:active,\n.btn-default.hover {\n    background-color: var(--color-2);\n    color: #fff !important;\n}\n.nav-tabs-custom>.nav-tabs>li.active {\n    border-top-color: var(--color-2);\n}\n.box.box-primary {\n    border-top-color: var(--color-2);\n}\n.box.box-danger {\n    border-top: none;\n}\n\n.box-header.with-border {\n    background: var(--color-2);\n    color: var(--white);\n}\n\n.main-footer {\n    background-image: var(--color-2) !important;\n    padding: 15px;\n    color: var(--white);\n}\n\n.admin-action {\n    list-style: none;\n    font-size: 14px;\n    line-height: 1.42857143;\n    color: #333 !important;\n}\n\n.btn-box-tool {\n    padding: 5px;\n    font-size: 12px;\n    background: transparent;\n    color: #ecf0f5;\n}\n\ndiv#track ul li {\n    list-style-type: none;\n    border-bottom: 2px solid #eee;\n    padding: 8px;\n    padding-left: 20px;\n    color: #666;\n    font-size: 14px;\n    margin-top: 20px;\n}\n\ndiv#track ul li a {\n    text-decoration: none;\n    color: #666;\n}\n\ndiv#track ul li span {\n    display: inline-block;\n    float: right;\n    padding-right: 10px;\n}\n\n.reposrtImage img {\n    width: 50px;\n    /* / top: 17px;/ position: absolute;\n    / right: -68px;/ left: 0px; */\n}\n\n.pagination>.active>a,\n.pagination>.active>a:focus,\n.pagination>.active>a:hover,\n.pagination>.active>span,\n.pagination>.active>span:focus,\n.pagination>.active>span:hover {\n    z-index: 3;\n    color: var(--white);\n    cursor: default;\n    background-color: var(--color-2);\n    border-color: var(--color-2);\n}\n\n\n\ni.fa.fa-edit.editIcon {\n    font-size: 18px;\n}\n\ni.fa.fa-fw.fa-remove.deleteIcon {\n    color: #b52929;\n    font-size: 20px;\n}\n\n\n\n.skin-blue .wrapper,\n.skin-blue .main-sidebar,\n.skin-blue .left-side {\n    background-color: #201804;\n}\n\nlabel{\n    color: black;\n}\n\n.switch{\n    margin-bottom: 0 !important;\n}\n\n.table>tbody>tr>td, \n.table>tbody>tr>th, \n.table>tfoot>tr>td, \n.table>tfoot>tr>th,\n.table>thead>tr>td, \n.table>thead>tr>th{\n    vertical-align: middle !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
